<template>
  <div :class="divClass">
    <div class="container">
      <h2 :class="h2Class">{{ title }}</h2>
      <div
        v-swiper:mySwiper="swiperOption(swiperSize)"
        class="swiper-container"
      >
        <div class="swiper-wrapper">
          <kcs-facility-panel-item
            :facility="facility"
            v-for="(facility, index) in facilities"
            :key="index"
          />
        </div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
      <kcs-btn v-if="isBtn" :url="url" name="すべて見る" />
    </div>
  </div>
</template>

<script>
import { methods } from '@/utils/methods'
import kcsFacilityPanelItem from '@/components/molecules/kcs-facility-panel-item.vue'
import kcsBtn from '@/components/atoms/kcs-btn.vue'
export default {
  components: {
    kcsFacilityPanelItem,
    kcsBtn
  },
  props: {
    facilities: {
      type: Array,
      required: true
    },
    divClass: {
      type: String,
      required: true
    },
    h2Class: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    isSmallGallery: {
      type: Boolean,
      default: false
    },
    isBtn: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: '/s/'
    }
  },
  computed: {
    swiperSize() {
      return this.isSmallGallery ? 4 : 3
    }
  },
  methods: {
    swiperOption(size) {
      return methods.swiperOption(size)
    }
  }
}
</script>
